// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"JJ-z","carouselContainer":"KJ-z"};